import React, { useState } from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Photo } from "@gaming/xds-react-js-icons";

import { xboxOnboardSiteLocationPrefix } from "../../constants";
import * as styles from "./PartnerAccountIconImage.module.css";

type PartnerAccountIconImageProps = Readonly<{
  accountId?: string;
  src?: string;
}>;

export const PartnerAccountIconImage = ({ accountId, src }: PartnerAccountIconImageProps) => {
  const [loadedImageUrl, setLoadedImageUrl] = useState<string>();
  const imageUrl =
    src ??
    `${xboxOnboardSiteLocationPrefix}/account-image${
      accountId ? `/${encodeURIComponent(accountId)}` : ""
    }`;
  const isImageLoaded = loadedImageUrl === imageUrl;

  return (
    <>
      {!isImageLoaded && (
        <Icon
          aria-hidden="true"
          className={styles.studioImageIcon}
          icon={Photo}
          iconSize={IconSize.Custom}
        />
      )}
      <img
        className={styles.image}
        src={imageUrl}
        alt=""
        hidden={!isImageLoaded}
        onLoad={() => setLoadedImageUrl(imageUrl)}
        onError={() => setLoadedImageUrl(undefined)}
      />
    </>
  );
};
